/* eslint-disable */

import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import { clone } from 'ramda';
import {
  Button,
  Drawer,
  Loader,
  DialogBox
} from 'quantux-ui';
import { blue, gray, salmon } from '../../theme';
import DocWriterWrapper from './doc-writer-wrapper';
import CropperDrawer from './cropper-drawer';
import CamInspectorDrawer from './cam-inspector-drawer';
import CameraDrawer from './camera-drawer';
import ThumbnailsPanel from '../thumbnails-panel';
import {
  base64ToFile,
  BASE_URL,
  findBase64ImageMimeType,
  findFileExtensionByMimeType,
  findPageById
} from '../../utils';

const DIALOG_WIDTH = window.innerWidth <= 576 ? (window.innerWidth - 16) : 350;
const MODES = {
  NONE: 'none',
  DRAW: 'draw',
  ERASE: 'erase',
  CAMERA: 'camera',
  CAM_INSPECTOR: 'cam-inspector',
  CROP: 'crop',
  ROTATE: 'rotate'
};

const DocWriterDrawer = (props) => {
  const [showInitLoader, setShowInitLoader] = useState(true);
  const [pages, setPages] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState('');
  const [activeMode, setActiveMode] = useState(MODES.NONE);
  const [currentPage, setCurrentPage] = useState(0);
  const [showThumbnailsPanel, setShowThumbnailsPanel] = useState(false);
  const [userDrawings, setUserDrawings] = useState([]);
  const [showSaveWarningDialog, setShowSaveWarningDialog] = useState(false);

  const [isEditingDocument, setIsEditingDocument] = useState(false);
  const [isInWritingMode, setIsInWritingMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedPageDataUrl, setSelectedPageDataUrl] = useState('');

  // -- Debug
  window.pages = pages;
  window.sd = selectedDocument;
  window.durl = selectedPageDataUrl;

  // --- Props ----------------------------------------------------------------
  const { formName } = props;

  // -------------------- Refs --------------------
  const docWriterWrapperRef = useRef();

  // -------------------- Effects --------------------
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowInitLoader(false);
      handleOnClickActivateDrawMode();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setSelectedDocument(props.activeDocId);
    setPages(props.caseDocs);
  }, [props.caseDocs, props.activeDocId]);

  useEffect(() => {
    // debugger; // eslint-disable-lin
    if (pages && Array.isArray(pages)) {
      const tmpIdx = pages.findIndex(page => page.id === selectedDocument);
      if (tmpIdx > -1) {
        setSelectedPageDataUrl(pages[tmpIdx].compositeImage || pages[tmpIdx].imageUrl);
        setCurrentPage(tmpIdx + 1);
      }
    }
  }, [pages, selectedDocument, userDrawings]);

  useEffect(() => {
    console.log('🔥🔥 DocWriterDrawer -> props.drawings effect.');
    setUserDrawings(props.drawings);
  }, [props.drawings]);

  // useEffect(() => {
  //   if (pages && Array.isArray(pages)) {
  //     const tmpIndex = pages.findIndex(el => el.id === selectedDocument);
  //     setCurrentPage(tmpIndex + 1);
  //   }
  // }, [selectedDocument]);

  // -------------------- Component Styles --------------------
  const styles = StyleSheet.create({
    canvasContainer: {
      position: 'relative',
      width: '100vw',
      // height: '100vh'
      height: '100%',
      zIndex: '1',
      overflow: 'hidden',
      touchAction: 'none' // Add this line
    },
    floatingToolbar: {
      position: 'absolute',
      display: 'flex',
      top: '10px',
      left: '10px',
      height: '32px'
    },
    toolbarBtn: {
      height: '32px',
      width: '32px',
      color: '#4C80C0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#001824',
      borderRadius: '4px',
      ':not(.sbtn):hover': {
        color: blue[400]
      },
      ':last-child': {
        marginLeft: '8px'
      }
    },
    activeToolbarBtn: {
      color: blue[400]
    },
    bgCanvas: {
      zIndex: '-1',
      position: 'absolute',
      left: '0',
      top: '0',
      touchAction: 'none'
    },
    drawerContainer: {
      background: blue[900],
      color: blue[200],
      height: '100vh',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      flexGrow: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0',
      background: blue[700]
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    toolbar: {
      height: '40px',
      background: gray[500],
      display: 'flex',
      flexGrow: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px'
    },
    toolbarLeft: {
      height: '40px',
      display: 'flex',
      alignItems: 'center'
    },
    toolbarRight: {
      height: '40px',
      display: 'flex',
      alignItems: 'center'
    },
    toolbarIcon: {
      fontSize: '22px',
      color: gray[300],
      fill: '#96C8FA',
      cursor: 'pointer',
      ':hover': {
        fill: blue[400],
        color: blue[400]
      }
    },
    badge: {
      position: 'absolute',
      top: '18px',
      right: '0px',
      padding: '0 4px',
      fontSize: '12px',
      fontWeight: 'bold',
      background: blue[500],
      borderRadius: '4px',
      color: 'white',
      cursor: 'pointer'
    },
    pageSelector: {
      display: 'flex',
      height: '30px',
      width: '120px',
      border: `1px solid ${gray[800]}`,
      borderRadius: '5px',
      marginLeft: '16px'
    },
    pageSelectorBtn: {
      fontSize: '12px',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: blue[800]
      // background: '#083050'
    },
    pageSelectorPageNumberDisplay: {
      width: '80x',
      background: 'black',
      color: gray[300],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: '1',
      height: '30px'
    },
    drawerContentArea: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // flexGrow: 1,
      // height: '100%',
      // height: 'calc(100vh - 80px)',
      // maxHeight: 'calc(100vh - 80px)',
      // minHeight: 'calc(100vh - 80px)',
      overflowY: 'hidden',
      color: gray[300],
      // position: 'relative',
      zIndex: '1'
    },
    compositeImgContainer: {
      width: '100%',
      height: 'calc(100% - 40px)',
      // background: '#000',
      padding: '8px',
      overflow: 'auto'
    },
    compositeImg: {
      maxWidth: '100%',
      width: '100%',
      height: 'auto'
    },
    groupIconContainer: {
      height: '24px',
      borderRadius: '4px',
      background: '#96C8FF',
      ':hover': {
        background: '#00A0FF',
      }
    },
    groupIcon: {
      ':hover': {
        fill: 'white'
      }
    }
  });

  // -------------------- Camera Related Event Handlers --------------------
  const handleOnClickCamera = () => {
    setActiveMode(MODES.CAMERA);
  };

  const handleOnCloseCameraDrawer = () => {
    setActiveMode(MODES.NONE);
  };

  const handleOnScan = async (imageDataUrl) => {
    const imgExtension = findFileExtensionByMimeType(findBase64ImageMimeType(imageDataUrl));
    setActiveMode(MODES.NONE);
    let updatedPages = clone(pages);
    const newDocId = Math.random().toString(36).slice(2);
    const newFileName = `file_${Math.random().toString(36).slice(2)}`;
    updatedPages = updatedPages.concat({
      id: newDocId,
      imageUrl: '',
      fileName: `${newFileName}${imgExtension}`,
      compositeImage: imageDataUrl
    });

    console.log(updatedPages);
    setPages(updatedPages);
    setSelectedDocument(newDocId);
    setActiveMode(MODES.CAM_INSPECTOR);
  };

  const handleOnCloseCamInspectorDrawer = () => {
    const formData = new FormData();
    formData.append('scheduleId', props.scheduleId);
    formData.append('formType', props.formType);
    formData.append('json', new Blob([JSON.stringify(pages)], { type: 'application/json' }));
    // formData.append('pages', JSON.stringify(pages));

    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(`${BASE_URL}/casesSchedule/updateTabCaseDocs`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const data = JSON.parse(result);
        console.log(data.msg);
        setActiveMode(MODES.NONE);
      })
      .catch(err => {
        console.log(err);
      });
  };

  // -------------------- Cropper Related Event Handlers --------------------
  const handleOnClickCropper = () => {
    setActiveMode(MODES.CROP);
  };

  const handleOnCropperClose = (updatedPages) => {
    setActiveMode(MODES.NONE);
    setPages(updatedPages);
  };

  const handleOnCloseDocWriter = (updatedPages) => {
    setActiveMode(MODES.NONE);
    setPages(updatedPages);
    // props.onClose(selectedDocument, props.drawings, updatedPages);
    props.onClose(updatedPages, props.formType);
  };


  const handleOnClickClose = () => {
    let shouldSave = false;
    if (docWriterWrapperRef.current) {
      const tmpDrawings = docWriterWrapperRef.current.getDrawings();
      shouldSave = Array.isArray(tmpDrawings) && tmpDrawings.length > 0;
    }

    try {
      if (shouldSave) {
        setShowSaveWarningDialog(true);
      } else {
        props.onClose(pages, props.formType);        
      }
    } catch (error) {
      console.error('Error saving the image:', error);
    }
    console.log('working on it...');
  };

  const handleOnThumbnailSelected = (id) => {
    setSelectedDocument(id);
  };

  // -------------------- Writing Mode Event Handlers --------------------
  const handleOnClickActivateDrawMode = () => {
    setIsInWritingMode(true);
    if (activeMode === MODES.NONE) {
      setIsEditingDocument(true);
      setActiveMode(MODES.DRAW);
      setTimeout(() => {
        if (docWriterWrapperRef.current) {
          docWriterWrapperRef.current.enableDrawMode();
        }
      }, 500);
    }
  };

  const handleOnClickPencil = () => {
    setActiveMode(MODES.DRAW);
    setTimeout(() => {
      if (docWriterWrapperRef.current) {
        docWriterWrapperRef.current.enableDrawMode();
      }
    }, 500);
  };

  const handleOnClickEraser = () => {
    setActiveMode(MODES.ERASE);
    setTimeout(() => {
      if (docWriterWrapperRef.current) {
        docWriterWrapperRef.current.enableEraseMode();
      }
    }, 500);
  };

  // Save drawing before selectging
  const saveDrawingData = async () => {
    return new Promise((resolve, reject) => {
      let userCurrentDrawings = [];
      if (docWriterWrapperRef.current) {
        userCurrentDrawings = docWriterWrapperRef.current.getDrawings();
        console.log(userCurrentDrawings);
      }

      const tmpIndex = findPageById(pages, selectedDocument);
      if (tmpIndex > -1) {
        const base64Img = pages[tmpIndex].compositeImage;
        const fileName = `${Math.random().toString(36).slice(2)}.jpg`;
        const img = base64ToFile(base64Img, fileName);

        const image = new Image();
        image.src = base64Img;

        image.onload = function () {
          const width = image.width;
          const height = image.height;
          const maxWidth = width > 1920 ? Math.floor(width / 2) : width
          const maxHeight = height > 1080 ? Math.floor(height / 2) : height;

          /* eslint-disable */
          new Compressor(img, {
            quality: 0.5,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            resize: 'cover',
            success: (result) => {
              const formData = new FormData();
              formData.append('scheduleId', props.scheduleId);
              formData.append('formType', props.formType);
              formData.append('imageId', selectedDocument);
              formData.append('drawings', JSON.stringify(userCurrentDrawings));
              formData.append('file', result);

              const reqHeaders = new Headers();
              const token = localStorage.getItem('token');
              reqHeaders.append('Authorization', `Bearer ${token}`);

              const requestOptions = {
                method: 'POST',
                body: formData,
                redirect: 'follow',
                headers: reqHeaders
              };

              fetch(`${BASE_URL}/casesSchedule/updateCompositeImageDrawing`, requestOptions)
                .then(response => response.text())
                .then(result => {
                  const data = JSON.parse(result);

                  const { compositeImageDataUrl } = data;
                  setSelectedPageDataUrl(compositeImageDataUrl);
                  // Update pages
                  const tmpIdx = pages.findIndex(page => page.id === selectedDocument);

                  const updatedPages = clone(pages);
                  console.log('Updated pages ... after saving from the thumbnail drawwer!');
                  console.log(updatedPages);
                  if (tmpIdx > -1) {
                    updatedPages[tmpIdx].compositeImage = compositeImageDataUrl;
                    setPages(updatedPages);
                  }

                  setIsSaving(false);
                  setActiveMode(MODES.DRAW);
                  // setIsEditingDocument(false);
                  // setIsInWritingMode(false);
                  // props.onClose(updatedPages, props.formType);
                  resolve(updatedPages);
                })
                .catch(err => {
                  console.log(err);
                  reject(err);
                });
            },
            error: (err) => {
              console.log(err.message);
              setErrorMessage(err.message);
              setShowErrorMessage(true);
            }
            /* eslint-enable */
          })
        };
      }
    });
  };

  // Save user cxurrent drawings and update composite image
  const handleOnClickSave = () => {
    setIsSaving(true);

    let userCurrentDrawings = [];
    if (docWriterWrapperRef.current) {
      userCurrentDrawings = docWriterWrapperRef.current.getDrawings();
      console.log(userCurrentDrawings);
    }

    const tmpIndex = findPageById(pages, selectedDocument);
    if (tmpIndex > -1) {
      const base64Img = pages[tmpIndex].compositeImage;
      const fileName = `${Math.random().toString(36).slice(2)}.jpg`;
      const img = base64ToFile(base64Img, fileName);

      const image = new Image();
      image.src = base64Img;

      image.onload = function () {
        const width = image.width;
        const height = image.height;
        const maxWidth = width > 1920 ? Math.floor(width / 2) : width
        const maxHeight = height > 1080 ? Math.floor(height / 2) : height;

        /* eslint-disable */
        new Compressor(img, {
          quality: 0.5,
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          resize: 'cover',
          success: (result) => {
            const formData = new FormData();
            formData.append('scheduleId', props.scheduleId);
            formData.append('formType', props.formType);
            formData.append('imageId', selectedDocument);
            formData.append('drawings', JSON.stringify(userCurrentDrawings));
            formData.append('file', result);

            const reqHeaders = new Headers();
            const token = localStorage.getItem('token');
            reqHeaders.append('Authorization', `Bearer ${token}`);

            const requestOptions = {
              method: 'POST',
              body: formData,
              redirect: 'follow',
              headers: reqHeaders
            };

            fetch(`${BASE_URL}/casesSchedule/updateCompositeImageDrawing`, requestOptions)
              .then(response => response.text())
              .then(result => {
                const data = JSON.parse(result);

                const { compositeImageDataUrl } = data;
                setSelectedPageDataUrl(compositeImageDataUrl);
                // Update pages
                const tmpIdx = pages.findIndex(page => page.id === selectedDocument);

                const updatedPages = clone(pages);
                if (tmpIdx > -1) {
                  updatedPages[tmpIdx].compositeImage = compositeImageDataUrl;
                  setPages(updatedPages);
                }

                setIsSaving(false);
                setActiveMode(MODES.NONE);
                setIsEditingDocument(false);
                setIsInWritingMode(false);
                props.onClose(updatedPages, props.formType);
              })
              .catch(err => {
                console.log(err);
              });
          },
          error: (err) => {
            console.log(err.message);
            setErrorMessage(err.message);
            setShowErrorMessage(true);
          }
          /* eslint-enable */
        })
      };
    }
  };

  const handleOnClickCancelSave = () => { };

  return (
    <Drawer
      placement='right'
      visible
      toggleDrawer={() => props.onClose()}
      zIndex="50000"
      showMask={false}
      style={{ border: 'none' }}
      width={window.innerWidth}
    >
      <div className={css(styles.drawerContainer)}>
        {/* -------------- Init Loader ----------------------------------------- */}
        {showInitLoader &&
          <div
            style={{
              position: 'absolute',
              height: '100vh',
              width: '100vw',
              // background: 'black',
              zIndex: '1'
            }}
          >
            <Loader iconType="cog" iconSize="5x" text={`Loading ${props.formName}`} />
          </div>
        }
        {/* -------------- Doc Writer Drawer Header ---------------------------- */}
        <div className={css(styles.drawerHeader)}>
          <div className='fx fx__hv-center'>
            <div className='ml-2'>
              {`Doc Writer - ${formName}`}
            </div>
          </div>
          <i
            className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
            onClick={handleOnClickClose}
          />
        </div>

        {/* -------------- Doc Writer Drawer Toolbar ---------------------------- */}
        <div
          className={css(styles.toolbar)}
        >
          {/* Toolbar left section */}
          <div className={css(styles.toolbarLeft)}>
            {/* Thumbnails drawer icon */}
            <div
              style={{
                position: 'relative',
                paddingTop: '6px'
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="30"
                fill="none"
                className={css(styles.toolbarIcon)}
                onClick={() => {
                  setShowThumbnailsPanel(!showThumbnailsPanel);
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M29.285 0H2.215C.99 0 0 1.258 0 2.813v24.375C0 28.741.99 30 2.215 30h27.07c1.224 0 2.215-1.258 2.215-2.813V2.813C31.5 1.258 30.51 0 29.285 0ZM12 27H3V3h9v24Zm3 0h13.5V3c0 .085-.01.142-.022.142H15.022C15.009 3.142 15 3.071 15 3v24Zm-4.5-16.5h-6v-6h6v6Zm-6 7.5h6v-6h-6v6Z"
                  clipRule="evenodd"
                />
              </svg>
              {/* Total pages badge */}
              <div
                className={css(styles.badge)}
                onClick={() => {
                  console.log('Not implemented yet!');
                }}
              >
                {/* {pages.length || 0} */}
                {pages && Array.isArray(pages) ? pages.length : 0}
              </div>
            </div>
            {/* Page Selector */}
            <div className={`ml-2 ${css(styles.pageSelector)}`}>
              {/* Go Back */}
              <div
                className={css(styles.pageSelectorBtn)}
                style={{
                  fontSize: '18px',
                  borderTopLeftRadius: '5px',
                  borderBottomLeftRadius: '5px',
                  color: '#5080B0'
                }}
                onClick={() => {
                  console.log('Not implemented yet!');
                }}
              >
                <i className='fa fa-minus-circle' />
              </div>
              {/* Current Page */}
              <div className={css(styles.pageSelectorPageNumberDisplay)}>
                {currentPage}
              </div>
              {/* Go Forward */}
              <div
                className={css(styles.pageSelectorBtn)}
                style={{
                  color: '#5080B0',
                  fontSize: '18px',
                  borderTopRightRadius: '5px',
                  borderBottomRightRadius: '5px'
                }}
                onClick={() => {
                  console.log('Not implemented yet!');
                }}
              >
                <i className='fa fa-plus-circle' />
              </div>
            </div>
          </div>
          {/* Toolbar right section - (View Mode) */}
          {!isInWritingMode &&
            <div
              className={css(styles.toolbarRight)}
              style={{ display: 'none' }}
            >
              {/* Pencil/Eraser/Text Group Icon Container */}
              <div
                className={`fx fx__hv-center pl-2 pr-2 ${css(styles.groupIconContainer)}`}
                onClick={handleOnClickActivateDrawMode}
              >
                {/* Pencil Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  onClick={handleOnClickActivateDrawMode}
                >
                  <path
                    fill="#004080"
                    fillRule="evenodd"
                    d="M15.74 2.34a.885.885 0 0 1 0 1.253l-1.626 1.626-3.333-3.333L12.408.26a.885.885 0 0 1 1.253 0l2.08 2.08ZM0 15.999v-3.333l9.83-9.83 3.333 3.333-9.83 9.83H0Z"
                    clipRule="evenodd"
                  />
                </svg>
                {/* Eraser Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  className='ml-1 mr-1'
                  onClick={handleOnClickActivateDrawMode}
                >
                  <path
                    fill="#004080"
                    fillRule="evenodd"
                    d="M.26 13.66a.885.885 0 0 1 0-1.253l1.626-1.626 3.333 3.333-1.627 1.626a.885.885 0 0 1-1.253 0L.26 13.66ZM16 .001v3.333l-9.83 9.83-3.333-3.333 9.83-9.83H16Z"
                    clipRule="evenodd"
                  />
                </svg>
                {/* Text Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="12"
                  fill="none"
                  onClick={handleOnClickActivateDrawMode}
                >
                  <path
                    fill="#004080"
                    d="M7.06 7.175 5.828 3.808a7.373 7.373 0 0 1-.19-.532c-.064-.205-.13-.427-.195-.665-.06.238-.124.462-.19.672a8.602 8.602 0 0 1-.188.54L3.84 7.174h3.22Zm3.325 3.822H8.929a.634.634 0 0 1-.4-.119.79.79 0 0 1-.23-.308l-.756-2.065H3.35l-.756 2.065a.671.671 0 0 1-.217.294.606.606 0 0 1-.4.133H.508L4.492.875h1.918l3.976 10.122Zm4.569-3.066c-.5.024-.92.068-1.26.133-.341.061-.614.14-.82.238-.205.098-.352.213-.44.343a.746.746 0 0 0-.133.427c0 .304.088.52.266.651.182.131.417.196.707.196.354 0 .66-.063.917-.189.261-.13.515-.326.763-.588v-1.21Zm-3.962-3.115c.826-.756 1.82-1.134 2.982-1.134.42 0 .795.07 1.127.21.331.136.611.327.84.574.228.243.401.535.518.875.121.341.182.714.182 1.12v4.536h-.784a.827.827 0 0 1-.378-.07c-.089-.051-.159-.151-.21-.3l-.154-.519c-.182.164-.36.308-.532.434a3.27 3.27 0 0 1-.54.308 2.745 2.745 0 0 1-.601.19c-.21.046-.444.07-.7.07-.304 0-.584-.04-.84-.12a1.89 1.89 0 0 1-.665-.37 1.652 1.652 0 0 1-.434-.61 2.162 2.162 0 0 1-.154-.847 1.657 1.657 0 0 1 .385-1.057c.14-.163.32-.317.539-.462.219-.144.487-.27.805-.378a6.868 6.868 0 0 1 1.12-.259c.424-.07.91-.112 1.456-.126v-.42c0-.48-.103-.835-.308-1.064-.206-.233-.502-.35-.89-.35-.28 0-.513.033-.7.098-.181.066-.342.14-.482.224l-.385.217a.736.736 0 0 1-.378.098.512.512 0 0 1-.308-.09.837.837 0 0 1-.203-.225l-.308-.553Z"
                  />
                </svg>
              </div>
              {/* Camera icon */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className='ml-2'
                style={{ display: 'none' }}
                onClick={handleOnClickCamera}
              >
                <mask id="path-1-inside-1_11323_11667" fill="white">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2ZM4.44639 7.49989C4.44639 7.89965 4.12296 8.22308 3.7232 8.22308C3.32343 8.22308 3 7.89965 3 7.49989V4.44639C3 3.64887 3.64887 3 4.44639 3H7.49989C7.89965 3 8.22308 3.32343 8.22308 3.7232C8.22308 4.12296 7.89965 4.44639 7.49989 4.44639H4.44639V7.49989ZM4.44639 19.5501H7.49989C7.89965 19.5501 8.22308 19.8736 8.22308 20.2733C8.22308 20.6731 7.89965 20.9965 7.49989 20.9965H4.44639C3.64887 20.9965 3 20.3477 3 19.5501V16.4966C3 16.0969 3.32343 15.7734 3.7232 15.7734C4.12296 15.7734 4.44639 16.0969 4.44639 16.4966V19.5501ZM19.5532 3H16.4997C16.1 3 15.7766 3.32343 15.7766 3.7232C15.7766 4.12296 16.1 4.44639 16.4997 4.44639H19.5532V7.49989C19.5532 7.89965 19.8767 8.22308 20.2764 8.22308C20.6762 8.22308 20.9996 7.89965 20.9996 7.49989V4.44639C20.9996 3.64887 20.3508 3 19.5532 3ZM19.5531 16.4966C19.5531 16.0969 19.8765 15.7734 20.2763 15.7734C20.676 15.7734 20.9994 16.0969 20.9994 16.4966V19.5501C20.9994 20.3477 20.3506 20.9965 19.5531 20.9965H16.4996C16.0998 20.9965 15.7764 20.6731 15.7764 20.2733C15.7764 19.8736 16.0998 19.5501 16.4996 19.5501H19.5531V16.4966ZM16.2547 9.53663L12.9969 6.2496C12.9442 6.19687 12.8856 6.15234 12.8235 6.11484C12.8071 6.10547 12.7895 6.09609 12.7719 6.08789C12.7639 6.08339 12.7551 6.07958 12.7466 6.07593L12.7391 6.07265C12.6325 6.02578 12.5165 6 12.3981 6H8.34355C7.87715 6 7.49982 6.37733 7.49982 6.84373V17.156C7.49982 17.6224 7.87715 17.9997 8.34355 17.9997H15.6559C16.1223 17.9997 16.4996 17.6224 16.4996 17.156V10.1308C16.4996 9.9081 16.4117 9.69483 16.2547 9.53663ZM15.1849 9.65932H12.8436V7.29688L15.1849 9.65932ZM8.34338 17.156H15.6557V10.4999H12.8433C12.3769 10.4999 11.9995 10.1226 11.9995 9.65618V6.84375H8.34338V17.156Z" />
                </mask>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2ZM4.44639 7.49989C4.44639 7.89965 4.12296 8.22308 3.7232 8.22308C3.32343 8.22308 3 7.89965 3 7.49989V4.44639C3 3.64887 3.64887 3 4.44639 3H7.49989C7.89965 3 8.22308 3.32343 8.22308 3.7232C8.22308 4.12296 7.89965 4.44639 7.49989 4.44639H4.44639V7.49989ZM4.44639 19.5501H7.49989C7.89965 19.5501 8.22308 19.8736 8.22308 20.2733C8.22308 20.6731 7.89965 20.9965 7.49989 20.9965H4.44639C3.64887 20.9965 3 20.3477 3 19.5501V16.4966C3 16.0969 3.32343 15.7734 3.7232 15.7734C4.12296 15.7734 4.44639 16.0969 4.44639 16.4966V19.5501ZM19.5532 3H16.4997C16.1 3 15.7766 3.32343 15.7766 3.7232C15.7766 4.12296 16.1 4.44639 16.4997 4.44639H19.5532V7.49989C19.5532 7.89965 19.8767 8.22308 20.2764 8.22308C20.6762 8.22308 20.9996 7.89965 20.9996 7.49989V4.44639C20.9996 3.64887 20.3508 3 19.5532 3ZM19.5531 16.4966C19.5531 16.0969 19.8765 15.7734 20.2763 15.7734C20.676 15.7734 20.9994 16.0969 20.9994 16.4966V19.5501C20.9994 20.3477 20.3506 20.9965 19.5531 20.9965H16.4996C16.0998 20.9965 15.7764 20.6731 15.7764 20.2733C15.7764 19.8736 16.0998 19.5501 16.4996 19.5501H19.5531V16.4966ZM16.2547 9.53663L12.9969 6.2496C12.9442 6.19687 12.8856 6.15234 12.8235 6.11484C12.8071 6.10547 12.7895 6.09609 12.7719 6.08789C12.7639 6.08339 12.7551 6.07958 12.7466 6.07593L12.7391 6.07265C12.6325 6.02578 12.5165 6 12.3981 6H8.34355C7.87715 6 7.49982 6.37733 7.49982 6.84373V17.156C7.49982 17.6224 7.87715 17.9997 8.34355 17.9997H15.6559C16.1223 17.9997 16.4996 17.6224 16.4996 17.156V10.1308C16.4996 9.9081 16.4117 9.69483 16.2547 9.53663ZM15.1849 9.65932H12.8436V7.29688L15.1849 9.65932ZM8.34338 17.156H15.6557V10.4999H12.8433C12.3769 10.4999 11.9995 10.1226 11.9995 9.65618V6.84375H8.34338V17.156Z" fill="#96C8FF"
                />
                <path
                  d="M4.44639 4.44639V3.44639H3.44639V4.44639H4.44639ZM4.44639 19.5501H3.44639V20.5501H4.44639V19.5501ZM19.5532 4.44639H20.5532V3.44639H19.5532V4.44639ZM19.5531 19.5501V20.5501H20.5531V19.5501H19.5531ZM12.9969 6.2496L13.7072 5.54566L13.7041 5.5425L12.9969 6.2496ZM16.2547 9.53663L15.5444 10.2406L15.5449 10.2411L16.2547 9.53663ZM12.8235 6.11484L13.3404 5.25878L13.3301 5.25256L13.3196 5.24659L12.8235 6.11484ZM12.7719 6.08789L12.2862 6.96201L12.3171 6.97915L12.3491 6.99407L12.7719 6.08789ZM12.7466 6.07593L12.3463 6.99229L12.3491 6.99353L12.7466 6.07593ZM12.7391 6.07265L12.3367 6.98812L12.3388 6.98901L12.7391 6.07265ZM12.8436 9.65932H11.8436V10.6593H12.8436V9.65932ZM15.1849 9.65932V10.6593H17.5839L15.8952 8.95539L15.1849 9.65932ZM12.8436 7.29688L13.5538 6.59295L11.8436 4.86727V7.29688H12.8436ZM15.6557 17.156V18.156H16.6557V17.156H15.6557ZM8.34338 17.156H7.34338V18.156H8.34338V17.156ZM15.6557 10.4999H16.6557V9.49991H15.6557V10.4999ZM11.9995 6.84375H12.9995V5.84375H11.9995V6.84375ZM8.34338 6.84375V5.84375H7.34338V6.84375H8.34338ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343145 -1 2H1ZM1 22V2H-1V22H1ZM2 23C1.44771 23 1 22.5523 1 22H-1C-1 23.6569 0.343145 25 2 25V23ZM22 23H2V25H22V23ZM23 22C23 22.5523 22.5523 23 22 23V25C23.6569 25 25 23.6569 25 22H23ZM23 2V22H25V2H23ZM22 1C22.5523 1 23 1.44771 23 2H25C25 0.343147 23.6569 -1 22 -1V1ZM2 1H22V-1H2V1ZM3.7232 9.22308C4.67525 9.22308 5.44639 8.45194 5.44639 7.49989H3.44639C3.44639 7.34737 3.57068 7.22308 3.7232 7.22308V9.22308ZM2 7.49989C2 8.45194 2.77115 9.22308 3.7232 9.22308V7.22308C3.87571 7.22308 4 7.34737 4 7.49989H2ZM2 4.44639V7.49989H4V4.44639H2ZM4.44639 2C3.09658 2 2 3.09658 2 4.44639H4C4 4.20115 4.20115 4 4.44639 4V2ZM7.49989 2H4.44639V4H7.49989V2ZM9.22308 3.7232C9.22308 2.77115 8.45194 2 7.49989 2V4C7.34737 4 7.22308 3.87571 7.22308 3.7232H9.22308ZM7.49989 5.44639C8.45194 5.44639 9.22308 4.67525 9.22308 3.7232H7.22308C7.22308 3.57068 7.34737 3.44639 7.49989 3.44639V5.44639ZM4.44639 5.44639H7.49989V3.44639H4.44639V5.44639ZM5.44639 7.49989V4.44639H3.44639V7.49989H5.44639ZM7.49989 18.5501H4.44639V20.5501H7.49989V18.5501ZM9.22308 20.2733C9.22308 19.3213 8.45194 18.5501 7.49989 18.5501V20.5501C7.34737 20.5501 7.22308 20.4258 7.22308 20.2733H9.22308ZM7.49989 21.9965C8.45194 21.9965 9.22308 21.2254 9.22308 20.2733H7.22308C7.22308 20.1208 7.34737 19.9965 7.49989 19.9965V21.9965ZM4.44639 21.9965H7.49989V19.9965H4.44639V21.9965ZM2 19.5501C2 20.8999 3.09658 21.9965 4.44639 21.9965V19.9965C4.20115 19.9965 4 19.7954 4 19.5501H2ZM2 16.4966V19.5501H4V16.4966H2ZM3.7232 14.7734C2.77114 14.7734 2 15.5446 2 16.4966H4C4 16.6492 3.87571 16.7734 3.7232 16.7734V14.7734ZM5.44639 16.4966C5.44639 15.5446 4.67525 14.7734 3.7232 14.7734V16.7734C3.57068 16.7734 3.44639 16.6492 3.44639 16.4966H5.44639ZM5.44639 19.5501V16.4966H3.44639V19.5501H5.44639ZM16.4997 4H19.5532V2H16.4997V4ZM16.7766 3.7232C16.7766 3.87571 16.6523 4 16.4997 4V2C15.5477 2 14.7766 2.77114 14.7766 3.7232H16.7766ZM16.4997 3.44639C16.6523 3.44639 16.7766 3.57068 16.7766 3.7232H14.7766C14.7766 4.67525 15.5477 5.44639 16.4997 5.44639V3.44639ZM19.5532 3.44639H16.4997V5.44639H19.5532V3.44639ZM20.5532 7.49989V4.44639H18.5532V7.49989H20.5532ZM20.2764 7.22308C20.429 7.22308 20.5532 7.34737 20.5532 7.49989H18.5532C18.5532 8.45194 19.3244 9.22308 20.2764 9.22308V7.22308ZM19.9996 7.49989C19.9996 7.34737 20.1239 7.22308 20.2764 7.22308V9.22308C21.2285 9.22308 21.9996 8.45194 21.9996 7.49989H19.9996ZM19.9996 4.44639V7.49989H21.9996V4.44639H19.9996ZM19.5532 4C19.7985 4 19.9996 4.20115 19.9996 4.44639H21.9996C21.9996 3.09658 20.903 2 19.5532 2V4ZM20.2763 14.7734C19.3242 14.7734 18.5531 15.5446 18.5531 16.4966H20.5531C20.5531 16.6492 20.4288 16.7734 20.2763 16.7734V14.7734ZM21.9994 16.4966C21.9994 15.5446 21.2283 14.7734 20.2763 14.7734V16.7734C20.1237 16.7734 19.9994 16.6492 19.9994 16.4966H21.9994ZM21.9994 19.5501V16.4966H19.9994V19.5501H21.9994ZM19.5531 21.9965C20.9029 21.9965 21.9994 20.8999 21.9994 19.5501H19.9994C19.9994 19.7954 19.7983 19.9965 19.5531 19.9965V21.9965ZM16.4996 21.9965H19.5531V19.9965H16.4996V21.9965ZM14.7764 20.2733C14.7764 21.2254 15.5475 21.9965 16.4996 21.9965V19.9965C16.6521 19.9965 16.7764 20.1208 16.7764 20.2733H14.7764ZM16.4996 18.5501C15.5475 18.5501 14.7764 19.3213 14.7764 20.2733H16.7764C16.7764 20.4258 16.6521 20.5501 16.4996 20.5501V18.5501ZM19.5531 18.5501H16.4996V20.5501H19.5531V18.5501ZM18.5531 16.4966V19.5501H20.5531V16.4966H18.5531ZM12.2867 6.95354L15.5444 10.2406L16.9649 8.83269L13.7072 5.54567L12.2867 6.95354ZM12.3066 6.9709C12.3071 6.97119 12.3002 6.96706 12.2898 6.95671L13.7041 5.5425C13.5882 5.42668 13.4641 5.33349 13.3404 5.25878L12.3066 6.9709ZM12.3491 6.99407C12.3416 6.99057 12.3362 6.9878 12.3331 6.98617C12.3299 6.98451 12.328 6.98342 12.3274 6.98309L13.3196 5.24659C13.2867 5.22775 13.2439 5.20462 13.1948 5.1817L12.3491 6.99407ZM12.3491 6.99353C12.3551 6.99611 12.3483 6.99323 12.3398 6.98928C12.3303 6.98492 12.3108 6.97567 12.2862 6.96201L13.2577 5.21377C13.1992 5.18127 13.1444 5.15844 13.1442 5.15834L12.3491 6.99353ZM12.3388 6.98901L12.3463 6.99229L13.147 5.15958L13.1395 5.1563L12.3388 6.98901ZM12.3981 7C12.3711 7 12.3505 6.99418 12.3367 6.98812L13.1415 5.15719C12.9145 5.05738 12.6619 5 12.3981 5V7ZM8.34355 7H12.3981V5H8.34355V7ZM8.49982 6.84373C8.49982 6.92962 8.42944 7 8.34355 7V5C7.32487 5 6.49982 5.82505 6.49982 6.84373H8.49982ZM8.49982 17.156V6.84373H6.49982V17.156H8.49982ZM8.34355 16.9997C8.42943 16.9997 8.49982 17.0701 8.49982 17.156H6.49982C6.49982 18.1747 7.32487 18.9997 8.34355 18.9997V16.9997ZM15.6559 16.9997H8.34355V18.9997H15.6559V16.9997ZM15.4996 17.156C15.4996 17.0701 15.57 16.9997 15.6559 16.9997V18.9997C16.6745 18.9997 17.4996 18.1746 17.4996 17.156H15.4996ZM15.4996 10.1308V17.156H17.4996V10.1308H15.4996ZM15.5449 10.2411C15.5162 10.2121 15.4996 10.1722 15.4996 10.1308H17.4996C17.4996 9.64399 17.3072 9.17754 16.9644 8.83215L15.5449 10.2411ZM12.8436 10.6593H15.1849V8.65932H12.8436V10.6593ZM11.8436 7.29688V9.65932H13.8436V7.29688H11.8436ZM15.8952 8.95539L13.5538 6.59295L12.1333 8.0008L14.4746 10.3632L15.8952 8.95539ZM15.6557 16.156H8.34338V18.156H15.6557V16.156ZM14.6557 10.4999V17.156H16.6557V10.4999H14.6557ZM12.8433 11.4999H15.6557V9.49991H12.8433V11.4999ZM10.9995 9.65618C10.9995 10.6749 11.8246 11.4999 12.8433 11.4999V9.49991C12.9292 9.49991 12.9995 9.57029 12.9995 9.65618H10.9995ZM10.9995 6.84375V9.65618H12.9995V6.84375H10.9995ZM8.34338 7.84375H11.9995V5.84375H8.34338V7.84375ZM9.34338 17.156V6.84375H7.34338V17.156H9.34338Z" fill="#96C8FF" mask="url(#path-1-inside-1_11323_11667)"
                />
              </svg>
              {/* Cropper icon */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none" xmlns="http://www.w3.org/2000/svg"
                className='ml-2'
                style={{ display: 'none' }}
                onClick={handleOnClickCropper}
              >
                <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2ZM20 8.36364V4H15.6364V5.45455H8.36364V4H4V8.36364H5.45455V15.6364H4V20H8.36364V18.5455H15.6364V20H20V15.6364H18.5455V8.36364H20ZM15.6374 17.0881H8.3647V15.6335H6.91016V8.3608H8.3647V6.90625H15.6374V8.3608H17.092V15.6335H15.6374V17.0881Z" fill="#96C8FF" />
              </svg>
              {/* Ellipsis icon */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className='ml-2'
                style={{ display: 'none' }}
              >
                <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2ZM5 9.99219C3.89543 9.99219 3 10.8876 3 11.9922C3 13.0968 3.89543 13.9922 5 13.9922C6.10457 13.9922 7 13.0968 7 11.9922C7 10.8876 6.10457 9.99219 5 9.99219ZM16.999 11.9922C16.999 10.8876 17.8945 9.99219 18.999 9.99219C20.1036 9.99219 20.999 10.8876 20.999 11.9922C20.999 13.0968 20.1036 13.9922 18.999 13.9922C17.8945 13.9922 16.999 13.0968 16.999 11.9922ZM12.001 9.99219C10.8964 9.99219 10.001 10.8876 10.001 11.9922C10.001 13.0968 10.8964 13.9922 12.001 13.9922C13.1055 13.9922 14.001 13.0968 14.001 11.9922C14.001 10.8876 13.1055 9.99219 12.001 9.99219Z" fill="#96C8FF" />
              </svg>
            </div>
          }
          {/* Draw Mode */}
          {isInWritingMode && !isSaving &&
            <div className={css(styles.toolbarRight)}>
              {/* Pencil Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                onClick={handleOnClickPencil}
              >
                <path
                  fill={activeMode === MODES.DRAW ? '#00A0FF' : '#96C8FF'}
                  fillRule="evenodd"
                  d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
                  clipRule="evenodd"
                />
                <path
                  fill="#004080"
                  fillRule="evenodd"
                  d="M20.74 6.34a.885.885 0 0 1 0 1.253l-1.626 1.626-3.333-3.333 1.627-1.626a.885.885 0 0 1 1.253 0l2.08 2.08ZM5 19.999v-3.333l9.83-9.83 3.333 3.333-9.83 9.83H5Z"
                  clipRule="evenodd"
                />
              </svg>
              {/* Eraser Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                className='ml-3'
                onClick={handleOnClickEraser}
              >
                <path
                  fill={activeMode === MODES.ERASE ? '#00A0FF' : '#96C8FF'}
                  fillRule="evenodd"
                  d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
                  clipRule="evenodd"
                />
                <path
                  fill="#004080"
                  fillRule="evenodd"
                  d="M4.26 17.66a.885.885 0 0 1 0-1.253l1.626-1.626 3.333 3.333-1.627 1.626a.885.885 0 0 1-1.253 0l-2.08-2.08ZM20 4.001v3.333l-9.83 9.83-3.333-3.333 9.83-9.83H20Z"
                  clipRule="evenodd"
                />
              </svg>
              {/* Text Icon (Disabled) */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                className='ml-3'
              >
                <path
                  // fill="#96C8FF"
                  fill="#96C8FF"
                  fillOpacity=".5"
                  fillRule="evenodd"
                  d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
                  clipRule="evenodd"
                />
                <path
                  fill="#004080"
                  d="M10.06 13.175 8.828 9.808a7.373 7.373 0 0 1-.19-.532c-.064-.205-.13-.427-.195-.665-.06.238-.124.462-.19.672a8.602 8.602 0 0 1-.188.54L6.84 13.174h3.22Zm3.325 3.822h-1.456a.634.634 0 0 1-.4-.119.792.792 0 0 1-.23-.308l-.756-2.065H6.35l-.756 2.065a.671.671 0 0 1-.217.294.606.606 0 0 1-.4.133h-1.47L7.492 6.875h1.918l3.976 10.122Zm4.569-3.066c-.5.024-.92.068-1.26.133-.341.061-.614.14-.82.238-.205.098-.352.213-.44.343a.745.745 0 0 0-.133.427c0 .304.088.52.266.651.182.131.417.196.707.196.354 0 .66-.063.917-.189.261-.13.515-.326.763-.588v-1.21Zm-3.962-3.115c.826-.756 1.82-1.134 2.982-1.134.42 0 .795.07 1.127.21.331.136.611.327.84.574.228.243.401.535.518.875.121.341.182.714.182 1.12v4.536h-.784a.827.827 0 0 1-.378-.07c-.089-.051-.159-.151-.21-.3l-.154-.519c-.182.164-.36.308-.532.434a3.27 3.27 0 0 1-.54.308 2.745 2.745 0 0 1-.601.19c-.21.046-.444.07-.7.07-.304 0-.584-.04-.84-.12a1.89 1.89 0 0 1-.665-.37 1.652 1.652 0 0 1-.434-.61 2.162 2.162 0 0 1-.154-.847 1.657 1.657 0 0 1 .385-1.057c.14-.163.32-.317.539-.462.219-.144.487-.27.805-.378a6.857 6.857 0 0 1 1.12-.259c.424-.07.91-.112 1.456-.126v-.42c0-.48-.103-.835-.308-1.064-.206-.233-.502-.35-.89-.35-.28 0-.513.033-.7.098a2.73 2.73 0 0 0-.482.224l-.385.217a.737.737 0 0 1-.378.098.513.513 0 0 1-.308-.09.838.838 0 0 1-.203-.225l-.308-.553Z" />
              </svg>
              {/* Save Button */}
              <Button
                btnType='primary'
                className='ml-3'
                style={{
                  display: 'none',
                  // display: 'flex',
                  height: '24px',
                  width: '52px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onClick={handleOnClickSave}
              >
                Save
              </Button>
            </div>
          }
          {/* Save Warning Dialog */}
          {/* {showSaveWarningDialog &&
            <WarningDialog
              show={showSaveWarningDialog}
              title="Cancel Schedule"
              message="Do you want to save?"
              onCancel={() => setShowSaveWarningDialog(false)}
              onContinue={() => {
                props.onClose(pages, props.formType);
              }}
            />
          } */}
          {showSaveWarningDialog &&
            <DialogBox
              showCloseBtn={false}
              initWidth={DIALOG_WIDTH}
              top={window.innerWidth <= 576 ? 48 : null}
              left={window.innerWidth <= 576 ? 8 : null}
              initHeight={265}
              isOpen={showSaveWarningDialog}
              onClose={() => {
                setShowSaveWarningDialog(false);
              }}
              maskBackground="#004080"
              maskOpacity={0.5}
              closeOnEscKey
              closeOnMaskClick={false}
              header={{
                overrideTheme: true,
                text: 'Warning! You Have Unsaved Changes!',
                backColor: '#082840',
                foreColor: 'yellow',
                closeColor: '#FF6060',
                fontStyle: 'bold',
                fontSize: '14px',
                icon: 'fa fa-exclamation-triangle'
              }}
            >
              <div className='p-2'>
                <div className='p-2 text-center'>
                  What do you want to do?
                </div>
                {/* Save Button */}
                <Button
                  className='mt-2'
                  btnType='primary'
                  style={{
                    height: '47px',
                    width: '334px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}
                  onClick={() => {
                    // props.onClose(pages, props.formType);
                    handleOnClickSave();
                  }}
                >
                  Save
                </Button>
                {/* Do tnot save Button */}
                <Button
                  className='mt-4'
                  btnType='danger'
                  style={{
                    height: '32px',
                    width: '334px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={() => {
                    props.onCloseWithoutSave();
                  }}
                >
                  Do Not Save
                </Button>
                {/* Cancel Button */}
                <Button
                  className='mt-4'
                  btnType='primary'
                  isOutlineBtn
                  style={{
                    border: `1px solid ${gray[400]}`,
                    color: gray[300],
                    height: '32px',
                    width: '334px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={() => setShowSaveWarningDialog(false)}
                >
                  Cancel
                </Button>
              </div>
            </DialogBox>
          }
          {/* Draw Mode with Saving */}
          {isInWritingMode && isSaving &&
            <div className={css(styles.toolbarRight)}>
              <Button
                btnType='primary'
                style={{
                  width: '120px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontSize: '14px'
                }}
                onClick={handleOnClickCancelSave}
              >
                <div
                  style={{
                    width: '104px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <span>Saving...</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="none"
                  >
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      d="M1.284 0h13.43c.71 0 1.284.574 1.286 1.284v13.432c0 .71-.574 1.284-1.284 1.284H1.284C.574 16 0 15.426 0 14.716V1.284C0 .574.574 0 1.284 0ZM8.92 7.998l2.314-2.314a.642.642 0 1 0-.908-.908L8.012 7.09 5.698 4.776a.642.642 0 1 0-.908.908l2.314 2.314-2.327 2.327a.642.642 0 1 0 .908.908l2.327-2.327 2.301 2.301a.642.642 0 1 0 .908-.908L8.92 7.998Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </Button>
            </div>
          }
        </div>

        {/* -------------- Doc Writer Drawer Container ---------------------------- */}
        <div className={css(styles.drawerContentArea)}>
          {showThumbnailsPanel &&
            <ThumbnailsPanel
              top={0}
              caseDocs={pages}
              activeDocId={selectedDocument}
              canUploadFiles={false}
              onThumbnailSelected={async (id) => {
                const updatedPages = await saveDrawingData();
                setPages(updatedPages);
                setSelectedDocument(id);
              }}
              onPageSelected={handleOnThumbnailSelected}
            />
          }

          {/* -------------- Cropper Drawer ---------------------------- */}
          {activeMode === MODES.CROP &&
            <CropperDrawer
              formType={props.formType}
              scheduleId={props.activeCaseSchedule._id}
              activeDocId={selectedDocument}
              cropperImgUrl={selectedPageDataUrl}
              caseDocs={pages}
              onClose={handleOnCropperClose}
              onCloseDocWriter={handleOnCloseDocWriter}
            />
          }

          {/* -------------- Camera Drawer ---------------------------- */}
          {activeMode === MODES.CAMERA &&
            <CameraDrawer
              caseDocs={pages}
              onClose={handleOnCloseCameraDrawer}
              onScan={handleOnScan}
            />
          }

          {/* -------------- Çam Inspector Drawer ---------------------------- */}
          {activeMode === MODES.CAM_INSPECTOR &&
            <CamInspectorDrawer
              newImageUrl={(() => {
                if (pages && Array.isArray(pages) && pages.length > 0 && selectedDocument.length > 0) {
                  const tmpId = pages.findIndex(el => el.id === selectedDocument);
                  return pages[tmpId].compositeImage;
                }
                return '';
              })()}
              selectedDocument={selectedDocument}
              onRotate={(rotatedImgUrl, sdId) => {
                const updatedPages = clone(pages);
                const tmpIdx = updatedPages.findIndex(el => el.id === sdId);
                updatedPages[tmpIdx].compositeImage = rotatedImgUrl;
                setPages(updatedPages);
              }}
              onClickCancel={() => {
                let updatedPages = clone(pages);
                updatedPages = updatedPages.filter(el => el.id !== selectedDocument);
                setPages(updatedPages);
                setSelectedDocument(pages[0].id);
                setActiveMode(MODES.NONE);
              }}
              onRetake={() => {
                let updatedPages = clone(pages);
                updatedPages = updatedPages.filter(el => el.id !== selectedDocument);
                setPages(updatedPages);
                setSelectedDocument(pages[0].id);
                setActiveMode(MODES.CAMERA);
              }}
              caseDocs={pages}
              onClose={handleOnCloseCamInspectorDrawer}
            />
          }

          {/* -------------- Doc Writer Wrapper ---------------------------- */}
          {isEditingDocument &&
            <DocWriterWrapper
              ref={docWriterWrapperRef}
              imageUrl={selectedPageDataUrl}
              // drawings={props.drawings}
              // drawings={userDrawings}
              drawings={[]}
            />
          }

          {/* -------------- Composite Image ---------------------------- */}
          {!isEditingDocument &&
            <div className={css(styles.compositeImgContainer)}>
              <img
                style={{ display: 'none' }}
                className={css(styles.compositeImg)}
                src={selectedPageDataUrl}
              />
            </div>
          }
        </div>
      </div>
    </Drawer>
  );
};

DocWriterDrawer.defaultProps = {
  formType: ''
};

function mapStateToProps({ caseSchedule }) {
  return { ...caseSchedule };
}

export default connect(mapStateToProps, {})(DocWriterDrawer);
